import React, { Component, Fragment } from "react";
import styles from "./CalendarSettings.local.scss";
import Dropzone from "react-dropzone";
import _ from "i18n";
import classnames from "classnames";
import Select from "react-select";
import DayPicker from "react-day-picker";
import { CloudUploadIcon } from "../Common/Icons";
import "react-day-picker/lib/style.css";
import MomentLocaleUtils from "react-day-picker/moment";

const WEEKDAYS_SHORT = {
  en: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  nl: ["Zon", "Maa", "Din", "Woe", "Don", "Vri", "Zat"],
  fr: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"]
};
const HOLIDAYS_COLOR = "#FF636E";
const WORKING_DAYS_COLOR = "#02AF8E";
const ANNUAL_HOLIDAYS_COLOR = "#F7953E";
const ABSENCES_COLOR = "#4695DB";
const OTHER_ABSENCES_COLOR = "#796AD9";
const PARTIAL_ABSENCES_COLOR = "#d13433";

class CalendarForm extends Component {
  handleDrop = acceptedFiles => {
    if (acceptedFiles.length === 0) return;
    this.props.setCalendarSelectedFiles(acceptedFiles);
  };

  renderCalendarSettingsForm = () => {
    const {
      monthNumber,
      lng,
      year,
      modifiers,
      isFreelancer,
      localSelectedDays: { from, to },
      inputDisplay,
      calendarLabel,
      selectDisplay,
      calendarLabelSelect,
      numericDisplay,
      calendarNumeric,
      backupSelect,
      attachments,
      notWorkingDays
    } = this.props;

    let defaultModifiers = {
      start: from,
      end: to,
      weekend: { daysOfWeek: [0, 6] }
    };
    // disabled: {[
    //   { daysOfWeek: [0, 6] },
    //   modifiers.holidays,
    //   modifiers.annualHolidays
    // ]}

    function formatWeekdayShort(i, lng) {
      return WEEKDAYS_SHORT[lng][i];
    }

    return (
      <div
        className={styles.calendar_form}
        onClick={event => {
          event.stopPropagation();
        }}
      >
        <table>
          {/***********************   CALENDAR  ***********************/}
          <tr>
            <td>
              <DayPicker
                onDayClick={this.props.handleDayClick}
                showOutsideDays
                canChangeMonth={false}
                month={new Date(year, monthNumber)}
                className="calendar"
                selectedDays={[from, { from, to }]}
                modifiers={{ ...defaultModifiers, ...modifiers }}
                localeUtils={{ ...MomentLocaleUtils, formatWeekdayShort }}
                locale={lng}
                disabledDays={
                  this.props.currentNavPage !== "ANNUAL_CALENDAR_SETTING"
                    ? [
                        ...modifiers.holidays,
                        ...modifiers.annualHolidays,
                        { daysOfWeek: [...[0, 6], ...notWorkingDays] }
                      ]
                    : []
                }
              />
            </td>
          </tr>
          {/***********************   CALENDAR  ***********************/}
          {/***********************   TAGS  ***********************/}
          <tr className={styles.associatedAccountBlock}>
            <td>
              {/*************     if ANNUAL CALENDAR      ************/}
              {this.props.currentNavPage === "ANNUAL_CALENDAR_SETTING" ? (
                <div className={styles.calendar_options}>
                  {this.renderCalendarOption(
                    "holidays",
                    HOLIDAYS_COLOR,
                    () => {},
                    "holidays"
                  )}
                  {this.renderCalendarOption(
                    "workingDays",
                    WORKING_DAYS_COLOR,
                    () => {},
                    "workingDays"
                  )}
                  {this.renderCalendarOption(
                    "annualHolidays",
                    ANNUAL_HOLIDAYS_COLOR,
                    () => {},
                    "annualHolidays"
                  )}
                </div>
              ) : (
                //*************     if COLLABORATOR CALENDAR      ************/
                <div
                  className={classnames(
                    styles.calendar_options,
                    styles.calendar_two_options
                  )}
                >
                  {this.renderCalendarOption(
                    isFreelancer ? "independentVacation" : "paidVacations",
                    ABSENCES_COLOR,
                    () => {},
                    "absence_1"
                  )}
                  {this.renderCalendarOption(
                    "partialVacations",
                    PARTIAL_ABSENCES_COLOR,
                    () => {},
                    "absence_3"
                  )}
                  {this.renderCalendarOption(
                    "othersVacations",
                    OTHER_ABSENCES_COLOR,
                    () => {},
                    "absence_2"
                  )}
                </div>
              )}
            </td>
          </tr>
          {/***********************   TAGS  ***********************/}
          {/***********************   INPUT  ***********************/}
          {inputDisplay && (
            <Fragment>
              <tr className={styles.associatedAccountBlock}>
                <td>
                  <input
                    type={"text"}
                    placeholder={_("Description") + " ..."}
                    value={_(calendarLabel)}
                    onChange={e => this.props.onChangeCalendarLabel(e)}
                  />

                  <img src={"/img/icons/pencil.svg"} alt={""} />
                </td>
              </tr>
              <tr className={styles.associatedAccountBlock}>
                <td>
                  <Select
                    value={
                      backupSelect &&
                      this.props.collaborators.find(
                        obj => obj.value === backupSelect
                      )
                    }
                    placeholder={_("backup")}
                    onChange={this.props.onSelectBackup}
                    options={this.props.collaborators}
                    className={classnames("select_medium", "created")}
                    classNamePrefix="ttp-select"
                    menuPlacement="auto"
                    isSearchable={false}
                  />
                </td>
              </tr>
            </Fragment>
          )}
          {selectDisplay && (
            <Fragment>
              <tr className={styles.associatedAccountBlock}>
                <td>
                  <Select
                    value={
                      calendarLabelSelect &&
                      this.props.holidaysTypes.find(
                        obj => obj.value === calendarLabelSelect
                      )
                    }
                    onChange={this.props.onSelectCalendarLabel}
                    options={this.props.holidaysTypes.filter(
                      item => item.abbriviation !== "CA"
                    )}
                    className={classnames("select_medium", "created")}
                    classNamePrefix="ttp-select"
                    menuPlacement="auto"
                    isSearchable={false}
                  />
                </td>
              </tr>
              <tr className={styles.associatedAccountBlock}>
                <div className="attachments-container">
                  <Dropzone
                    className=" row attachments-dropzone attachments-dropzone-xs"
                    ref={node => {
                      this.dropzone = node;
                    }}
                    onDrop={this.handleDrop}
                    multiple={true}
                    accept={".png,.pdf,.jpeg"}
                  >
                    <div>
                      <span className="icon_upload">
                        <CloudUploadIcon />
                      </span>
                      {attachments && attachments.length > 0 ? (
                        <div>
                          {attachments.map(file => {
                            return (
                              <p>
                                <span className="icon icon-paper-clip" />{" "}
                                {file.name}
                              </p>
                            );
                          })}
                        </div>
                      ) : (
                        <p>
                          <span
                            className="drag_message"
                            dangerouslySetInnerHTML={{
                              __html: _("dragMessage")
                            }}
                          />
                        </p>
                      )}
                    </div>
                  </Dropzone>
                </div>
              </tr>
            </Fragment>
          )}
          {numericDisplay && (
            <Fragment>
              <tr className={styles.associatedAccountBlock}>
                <td>
                  <input
                    type={"number"}
                    min="1"
                    placeholder={_("countHours") + " ..."}
                    value={_(calendarNumeric)}
                    onChange={e => this.props.onChangeCalendarNumeric(e)}
                  />

                  <img src={"/img/icons/pencil.svg"} alt={""} />
                </td>
              </tr>
            </Fragment>
          )}
          {/***********************   INPUT  ***********************/}
        </table>
      </div>
    );
  };

  renderCalendarOption = (label, color, onClick, option) => {
    const { activatedOption } = this.props;
    return (
      <div
        className={styles.calendar_option}
        onClick={() => this.props.onCalendarOptionClick(option)}
      >
        <span
          className={classnames(
            styles.calendar_option_button,
            activatedOption === option ? styles.activated : ""
          )}
          style={
            activatedOption === option
              ? { background: color }
              : { borderColor: color }
          }
        />
        <span>{_(label)}</span>
      </div>
    );
  };

  render() {
    return this.renderCalendarSettingsForm();
  }
}

export default CalendarForm;



// WEBPACK FOOTER //
// ./src/components/CalendarSettings/CalendarForm.js